module.exports = __webpack_public_path__ + "support_icon.b3260bad166c48a6e5e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/support_icon.svg
// module id = 1410
// module chunks = 3